import React from 'react';
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

const SpinWheelEmbed = () => {
  const iframeRef = useRef(null);
  const { t, i18n } = useTranslation();

  return (
    <>
      <iframe 
        ref={iframeRef}
        src="/spinwheel/index.html" 
        onLoad={() => {
          const iframe = iframeRef.current;
          if (!iframe) return;
            
          iframe.contentWindow.postMessage({
            type: "TRANSLATIONS",
            lang: i18n.language,
            data: {
              title: t("spinwheel.title"),
              points: t("spinwheel.points"),
              spin: t("spinwheel.spin"),
              youHave: t("spinwheel.youhave"),
              luckySpins: t("spinwheel.luckyspins"),
              tryNow: t("spinwheel.trynow"),
              congratulations: t("spinwheel.congratulations"),
              winText: t("spinwheel.wintext"),
              back: t("spinwheel.back"),
            }
          }, "*");
        }}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          border: 'none',
          margin: 0,
          padding: 0,
          display: 'block',  // important: avoid baseline gap
          background: '#0b1b35'
        }}
        title="SpinWheel"
      />
      </>
  );
}

export default SpinWheelEmbed;